import * as React from 'react';
import Panel from './Panel';

interface ConnectingProps {
    retryConnectionAt?: number;
    onRetryConnection: () => void;
}

export class Connecting extends React.Component<ConnectingProps> {
    public render(): JSX.Element {
        return (
            <div className="App-panels">
                <Panel>
                    <p>Connecting...</p>
                    {this.renderRetryCountdown()}
                </Panel>
            </div>
        );
    }

    private renderRetryCountdown(): JSX.Element | null {
        if (!this.props.retryConnectionAt) return null;
        const timeLeft = Math.ceil(Math.max(this.props.retryConnectionAt - Date.now(), 0) / 1000);
        return (
            <div>
                {this.props.retryConnectionAt ? (
                    <div>Reconnecting in {timeLeft === 1 ? '1 second' : `${timeLeft} seconds`}</div>
                ) : null}
                <button onClick={this.props.onRetryConnection}>Retry now</button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Connecting.tsx